'use client';

import React from 'react';
import Link from 'next/link';
import { ButtonHTMLAttributes, AnchorHTMLAttributes } from 'react';

import { SolidButtonProps } from './types';

import {
  StyledAnchorSolid,
  StyledButtonSolid,
  StyledLinkSolid,
} from './styles';

const SolidButton: React.FC<SolidButtonProps> = ({
  actionType = 'button',
  link = '/',
  action,
  disabled,
  children,
  className,
  ...restProps
}) => {
  const combinedClassName = `${className || ''} ${disabled ? 'disabled' : ''}`;
  const handleAction = action || (() => true);

  /* ---------------- LINK (internal) ---------------- */

  if (actionType === 'link' || actionType === 'internal') {
    const props = restProps as AnchorHTMLAttributes<HTMLAnchorElement>;

    return (
      <StyledLinkSolid
        as={Link}
        href={link}
        className={combinedClassName}
        {...props}
      >
        {children}
      </StyledLinkSolid>
    );
  }

  /* ---------------- ANCHOR (external) ---------------- */

  if (actionType === 'anchor' || actionType === 'external') {
    const props = restProps as AnchorHTMLAttributes<HTMLAnchorElement>;

    return (
      <StyledAnchorSolid
        href={link}
        target="_blank"
        rel="noreferrer noopener"
        className={combinedClassName}
        {...props}
      >
        {children}
      </StyledAnchorSolid>
    );
  }

  /* ---------------- BUTTON ---------------- */

  const props = restProps as ButtonHTMLAttributes<HTMLButtonElement>;

  return (
    <StyledButtonSolid
      disabled={disabled}
      className={combinedClassName}
      onClick={handleAction}
      {...props}
    >
      {children}
    </StyledButtonSolid>
  );
};

export default SolidButton;
